import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { Line } from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography';
import { styles } from '../CSS/Styles';


class ManagementChart extends Component {

    render() {
        const { classes } = this.props
        let data = this.props.data
        console.log(data)
        let option = {
            plugins: {
                datalabels: {
                    display: false,
                    color: 'white',
                    anchor: 'end',
                    align: 'start'
                }
            },
            scales: {
                yAxes: [{
                    gridLines: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false
                    }
                }],
                xAxes: [{
                    barPercentage: 0.65,
                    gridLines: {
                        display: false,
                        drawBorder: true
                    },
                    ticks: {
                        fontSize: 10
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'Amount'
                    }
                }]
            },
            title: {
                display: false
            },
            legend: {
                position:'bottom',
                display: false
            }
        }

        return (
            <div className={classes.details}>
                {this.props.title === null ? null :
                    this.props.title.map((title, index) => {
                        if (index === 0) {
                            return (
                                <Typography className={classes.title}>
                                    {title}
                                </Typography>
                            )
                        }
                        if (title === '') {
                            return (
                                <Typography className={classes.subtitle}/>
                            )
                        }
                        return (
                            <div>
                                {title.split(' ').map((title)=>{
                                    return (
                                        <Typography variant='subtitle' style={{ color:(isNaN(title) ? 'black' : 'blue'), display:'inline', minHeight: '18px'}}>
                                            {title + ' '}
                                        </Typography>
                                    )
                                })}
                            </div>
                        )
                    })
                }
                <br/>
                <Line data={data} height={100} options={option}/>
            </div>
        )
    }
}
export default withStyles(styles)(ManagementChart);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/linechart.js